import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pAuth: false,
    pUseremail: "",
    pUserDetail: "",
    pforgetpasswordStatus: "",
    ploginStatus: "",
    pUserAdminidId: "",
    pOrgDetails: "",
    pOrgId: "",
    pApiId: ""
  },
  getters: {
    get_auth: state => {
      return state.auth || false;
    },
    get_orgId: state => {
      return state.pOrgId;
    },
    get_userDetail: state => {
      return state.pUserDetail;
    },
    get_useremail: state => {
      return state.pUseremail;
    },
    get_loginStatus: state => {
      return state.ploginStatus;
    },
    get_forPasswordStatus: state => {
      return state.pforgetpasswordStatus;
    },
    get_UserAdminidId: state => {
      return state.pUserAdminidId;
    },
    get_OrgDetails: state => {
      return state.pOrgDetails;
    },
    get_ApiId: state => {
      return state.pApiId;
    }
  },
  mutations: {
    SET_AUTH(state, status) {
      state.auth = status;
    },
    SET_UserDetail(state, userDetail) {
      state.pUserDetail = userDetail;
    },
    SET_USEREMAIL(state, useremail) {
      state.pUseremail = useremail;
    },
    SET_USERAdminidID(state, useremailId) {
      state.pUserAdminidId = useremailId;
    },

    SET_forPasswordStatus(state, forPassStatus) {
      state.pforgetpasswordStatus = forPassStatus;
    },
    SET_loginStatus(state, loginStatus) {
      state.ploginStatus = loginStatus;
    },
    SET_OrgId(state, orgId) {
      state.pOrgId = orgId;
    },
    SET_ApiId(state, apiId) {
      state.pApiId = apiId;
    },
    SET_OrgDetails(state, orgDetails) {
      state.pOrgDetails = orgDetails;
    }

  },
  actions: {
    removeAuth(context) {
      context.commit("SET_USEREMAIL", "");
    },
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
